import { ErrorMessages } from "../../../../enums";
import { ErrorHandlingModeType } from "../../../Configurator/Types/ConfiguratorTypes";
import { ErrorCodes } from "../../../Exception/ErrorCodes";
import { ErrorStatuses } from "../../../Exception/ErrorStatuses";
import BaseValidator from "../../../Global/Validator/BaseValidator";
import BracketGameFixtures from "../Models/Prediction/RequestBody/BracketGameFixtures";
import BracketGamePredictionRequestBody from "../Models/Prediction/RequestBody/BracketGamePredictionRequestBody";

export default class BracketGameValidator extends BaseValidator {
  constructor(errorHandlingMode: ErrorHandlingModeType) {
    super(errorHandlingMode);
  }

  public validatePrediction = (
    prediction: BracketGamePredictionRequestBody
  ) => {
    if (
      !prediction.fixtures ||
      !Array.isArray(prediction.fixtures) ||
      prediction.fixtures.length === 0
    ) {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_METHOD_CALL,
        ErrorMessages.REQUIRED_FIXTURES_FIELD
      );
    }

    const validKeys = Object.keys(new BracketGameFixtures());

    for (const f of prediction.fixtures) {
      if (
        Object.keys(f).length !== validKeys.length ||
        Object.keys(f).some((key) => !validKeys.includes(key))
      ) {
        this.throwException(
          ErrorCodes.BAD_METHOD_CALL,
          ErrorStatuses.INVALID_METHOD_CALL,
          ErrorMessages.INVALID_FIXTURES_FIELD
        );
      }
    }

    if (
      prediction.tiebreaker &&
      (!prediction.tiebreaker.statTotal ||
        !Number.isInteger(prediction.tiebreaker.statTotal))
    ) {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_METHOD_CALL,
        ErrorMessages.INVALID_TIEBREAKER_FIELD
      );
    }
  };
}
